export const hemeraColors = {
  primaryBackground: '#FCFBF9',
  onImageBackground: '#FFFFFF',
  onIconsAndTextButtons: '#FFFFFF',
  onIconsAndTextButtonsVariant: '#FFFFFF',
  secondaryBackground: '#FFFFFF',
  selectedAndDetailBackground: '#EAE8E1',
  borderLine: '#DCD9D5',
  placeholderText: '#7B88B3',
  menuBackground: '#DCD9D5',
  currentStep: '#252F51',
  onSecondaryAndDetailBackground: '#252F51',
  hoverMenuBackground: '#F1EEEA',
  mainFocused: '#4158A7',
  highlight: '#FC805B',
  tradingDown: '#FC805B',
  tradingUp: '#FC805B',
  off: '#D3D6DB',
  lower: '#7A8298',
  footerBackground: '#252F51',
  onFooterBackground: '#FFFFFF',
  popupWindow: '#252F51',
  popupWindowTitle: '#FFFFFF',
  iconsOnFooterBackground: '#fC805B',
  primaryDisabledBackground: '#E9E9E9',
  secondaryDisabledBackground: '#FBFBFB',
  primaryDisabledText: '#C6C5C5',
  secondaryDisabledText: '#DCD9D5',
  scrollOnDetailBackground: '#D0D2DC',
  scrollOnPrimaryBackground: '#EBE8E4',
  infoBackground: '#F8F5EE',
  nextStep: '#C1CAE5',
  previousStep: '#7E9BDA',
  iconsOnMenuBackground: '#9DA3AE',
  mainFocusedSoothing: '#E6ECFD',
  highlightSoothing: '#FFE6DF',
  pillBorder: '#AB9182',
  pillBackgroundGloomy: '#C2BEAF',
  pillBackgroundLight: '#F5F4F1',
  dividerOnPrimaryBackground: '#E2E6F1',
  label: '#A19FB3',
  homePageBackground: '#FCFBF9',
  onHomePageBackground: '#252F51',
  refreshButton: '#252F51',
  dashboardDivider: '#DCD9D5',
  star: '#FFCF06',
  up: '#3FC721',
  down: '#F52B2B',
  inert: '#95B7C6',
  scrollOnInfoBackground: '#DFDCD6',
  actionBar: '#F3F0EA',
  onInfoBackground: '#252F51',
  onPrimaryBackground: '#252F51',
  lockedBackground: 'rgba(37, 47, 81, 0.65)',
  hoverHighlight: '#FB9677',
  variantOnInfoBackground: '#252F51',
  variantOnPrimaryBackground: '#252F51',
  graphBackground: '#F3F2F0',
  disabledAndHoverOnInfoBackground: '#B9BFD1',
  disabledOnPrimaryBackground: '#B9BFD1',
  iconsSelectedOnMenu: '#252F51',
  selectedBarOnMenu: '#252F51',
  selectedTextButtonMenu: '#FC805B',
  newsBackground: '#F5F5F4',
};
